
























































































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import ScientficProjectAdd from './scientficProjectAdd.vue'
import AdvancedSearch from '../../../components/tools/advancedSearch.vue'
@Component({
    name:'scientficProject',
    components: {
        ScientficProjectAdd,
        AdvancedSearch
    }
})
export default class ScientficProjectList extends AbpBase  {
    initData:any = {
        column:{   //自定义显示列
            visible:false,
            dropdownCheckAllGroup:[],
            indeterminate:false,
            checkAll:true, //是否全选 true:全 false:不
            dropdownCheckAllList:[],//自定义列的列表
        },
        searchInfo: {
            ProjectName: null,
            TrusteeshipDepId: null,
            ProjectCatalogId: null,
            BeginDt: null,
            OnlyBuilding: false,
            ProjectSource:null,
        },
        dicData: {allDictionary: {}},
        tableData: {
            title: [
                {
                    title: '项目编号',
                    key: 'projectCode',
                    width: 150,
                    align: 'center'
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    minWidth: 450,
                    align: 'left',
                    className: 'font-blue',
                    render: (h:any,params:any) => {
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.projectName)
                    }
                },
                {
                    title: '项目类别',
                    key: 'projectCatalog',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.projectCatalog ? params.row.projectCatalog.catalogName : '')
                        ])
                    }                        
                },
                {
                    title: '批准年度',
                    key: 'ratifyYear',
                    width: 150,
                    align: 'center'
                },
                {
                    title: '立项部门',
                    key: 'projectSource',
                    width: 150,
                    align: 'center'
                },
                {
                    title: '项目托管部门',
                    key: 'trusteeshipDep',
                    width: 150,
                    align: 'center',                        
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.trusteeshipDep ? params.row.trusteeshipDep.displayName : '')
                        ])
                    }    
                },
                {
                    title: '项目负责人',
                    key: 'projectLeader',
                    width: 150,
                    align: 'center',                        
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.projectLeader ? params.row.projectLeader.name : '')
                        ])
                    }  
                },
                {
                    title: '合同金额（万元）',
                    key: 'contractAmountFormat',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.contract ? params.row.contract.contractAmountFormat : '')
                        ])
                    }    
                },
                {
                    title: '财政拨款（万元）',
                    key: 'financialAmount',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row ? params.row.financialAmountFormat : '')
                        ])
                    }    
                },
                {
                    title: '结题时间',
                    key: 'concludingDt',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('Row', [
                            h('Col', {}, params.row.concludingDt ? params.row.concludingDt.toLocaleString().substring(0,10).replace(/\//g, '-') : '')
                        ])
                    }    
                },
                // {
                //     title: '信息一览表',
                //     key: 'excel',
                //     width: 150,
                //     align: 'center',
                //     render: (h:any, params:any)=>{
                //         return h('a',{
                //             on:{
                //                 click: ()=> {
                //                     this.exportExcel(params.row);
                //                 }
                //             }
                //         },'一览表')
                //     }    
                // }
            ],
            content: [],
            loading: true,
            totalCount: 0,
            pageSizeOpts:[10,20,30,40,100],
            newTitle:[],
            currentIndex:2,
        },
        otherTable:[
            {
                title: '合同编号',
                key: 'contractCode',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.contract ? params.row.contract.contractCode:'')
                    ])
                }    
            },
            {
                title: '合同名称',
                key: 'contractName',
                width: 300,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.contract ? params.row.contract.contractName:'')
                    ])
                }    
            },
            {
                title: '合作单位',
                key: 'cooperateUnit',
                width: 300,
                align: 'center' 
            },
            {
                title: '开题时间',
                key: 'openingDt',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.openingDt ? params.row.openingDt.toLocaleString().substring(0,10).replace(/\//g, '-') : '')
                    ])
                }    
            },
            {
                title: '项目级别',
                key: 'projectLevelDesc',
                width: 150,
                align: 'center'
            },
            {
                title: '合同起始日期',
                key: 'beginDt',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.contract && params.row.contract.beginDt ? params.row.contract.beginDt.toLocaleString().substring(0,10).replace(/\//g, '-') : '' )
                    ])
                }    
            },
            {
                title: '合同截止日期',
                key: 'endDt',
                width: 150,
                align: 'center',
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.contract && params.row.contract.endDt ? params.row.contract.endDt.toLocaleString().substring(0,10).replace(/\//g, '-') : '')
                    ])
                }    
            },
            {
                title: '执行项目负责人',
                key: 'executeLeader',
                width: 150,
                align: 'center',                        
                render: (h:any, params:any)=>{
                    return h('Row', [
                        h('Col', {}, params.row.executeLeader ? params.row.executeLeader.name : '')
                    ])
                }  
            },
            {
                title: '延期原因',
                key: 'delayCause',
                width: 150,
                align: 'center'
            },
            {
                title: '公开状态',
                key: 'isPublic',
                width: 150,
                align: 'center'
            },
            {
                title: '备注',
                key: 'remark',
                width: 150,
                align: 'center'
            }
        ],
        modalData: {
            status: false,
            loading: true
        },
        isShowAdvancedSearch:false,//高级搜索是否显示
        indBool:true, // 判断增加额外的列只执行一次
    }
    dropdownHandleOpen () { //自定义显示列显示隐藏
        this.initData.column.visible = !this.initData.column.visible;
    }
    dropdownHandleCheckAll(){  //自定义列全选
        this.initData.column.dropdownCheckAllGroup = [];
        if (this.initData.column.indeterminate) {
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.checkAll = !this.initData.column.checkAll;
        }
        this.initData.column.indeterminate = false;
        if (this.initData.column.checkAll) {
            this.initData.tableData.title.forEach((item:any,index:any) => {
                this.initData.column.dropdownCheckAllGroup.push(item.key)
            });
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = true;
            } )
        } else {
            this.initData.column.dropdownCheckAllGroup = [];
            this.initData.column.dropdownCheckAllList.map( (item:any) => {
                return item.isVisiblity = false;
            } )
        }
    }
    dropdownCheckAllGroupChange(res:any){  //自定义列单选
        if (res.length === this.initData.column.dropdownCheckAllList.length) {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = true;
        } else if (res.length > 0) {
            this.initData.column.indeterminate = true;
            this.initData.column.checkAll = false;
        } else {
            this.initData.column.indeterminate = false;
            this.initData.column.checkAll = false;
        }
        //获取得到的值
        this.initData.column.dropdownCheckAllList.map( (item:any) => {
            let bool:any = false;
            res.forEach( (val:any) => {
                if(item.fieldEnName == val){
                    bool = true;
                }
            } )
            if(!bool){
                return item.isVisiblity = false;
            }else{
                return item.isVisiblity = true;
            }
        } )
    }
    async saveDropdownColumn(){//保存列
    //     return;
        await Ajax.post('/api/services/app/UserHabits/SaveResearchProjectLedgerAsync',this.initData.column.dropdownCheckAllList);
        await this.$store.dispatch('session/GetCurrentLoginInformations');
        await this.setDropdownCheckAllList();
        this.initData.column.visible = false;
    }
    setDropdownCheckAllList(){//设置初始化的列
        this.initData.column.dropdownCheckAllGroup = [];
        if(this.$store.state.session.userHabits.ledger.researchProjectLedger.length){
            this.initData.column.dropdownCheckAllList = this.$store.state.session.userHabits.ledger.researchProjectLedger;
            this.$store.state.session.userHabits.ledger.researchProjectLedger.forEach( (item:any) => {
                if(item.isVisiblity){
                    this.initData.column.dropdownCheckAllGroup.push(item.fieldEnName);
                }
            } )
            //设置全选按钮
            if (this.initData.column.dropdownCheckAllGroup.length === this.initData.column.dropdownCheckAllList.length) {
                this.initData.column.indeterminate = false;
                this.initData.column.checkAll = true;
            }else{
                this.initData.column.indeterminate = true;
                this.initData.column.checkAll = false;
            }
        }else{
            this.initData.tableData.title.forEach((item:any,index:any) => {
                this.initData.column.dropdownCheckAllList.push({
                    fieldEnName:item.key,
                    fieldZhName:item.title,
                    isVisiblity:true,
                    isFixed:false,
                })
                this.initData.column.dropdownCheckAllGroup.push(item.key);
            });
            this.initData.otherTable.forEach((item:any,index:any) => {
                this.initData.column.dropdownCheckAllList.push({
                    fieldEnName:item.key,
                    fieldZhName:item.title,
                    isVisiblity:false,
                    isFixed:false,
                })
            });
        }
        this.changeColumn();
    }
    changeColumn(){ // 改变列
        let data:any = [];
        // 只执行一次增加额外的列
        if(this.initData.indBool){
            this.initData.tableData.title = this.initData.tableData.title.concat(this.initData.otherTable);
            this.initData.indBool = false;
        }
        // return;
        this.initData.tableData.title.forEach( (item:any) => {
            this.initData.column.dropdownCheckAllGroup.forEach( (val:any) => {
                if(item.key == val){
                    data.push(item);
                }
            } )
        } )
        //格式化一览表
        if(this.initData.searchInfo.AuditStatus == undefined || this.initData.searchInfo.AuditStatus == 2){
            data.push({
                    title: '信息一览表',
                    key: 'excel',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('a',{
                            on:{
                                click: ()=> {
                                    console.log(this.initData.searchInfo.AuditStatus)
                                    this.exportExcel(params.row);
                                }
                            }
                        },'一览表')
                    }    
                });
        }
        this.initData.tableData.newTitle = data;
    }
    // 导出预览表
    exportExcel(data:any){
        (this as any).$root.Export({id:data.id}, '/api/ResearchFile/ExportProjectSheetAsync', '一览表', 'xls');
    }
    //高级搜索
    ShowSearch(){
        (this as any).$refs.advancedSearch.Show(!this.initData.isShowAdvancedSearch);
        this.initData.isShowAdvancedSearch = !this.initData.isShowAdvancedSearch;
    }
    AdvancedSearch(data:any){
        Object.assign(this.initData.searchInfo, data);
        this.GetData();
    }
    ClearSearch() {
        this.initData.searchInfo = {};
    }
    //弹窗状态
    ShowModal(status:boolean) {
        (this as any).reloadComponent('scientficProjectAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name:'scientficProjectAdd',
            })
        } ) 
        // this.initData.modalData.status = status;
    }
    //重置月份弹窗loading
    resetMonthLoading() {
        setTimeout(() => {
            this.initData.modalData.loading = false;
            this.$nextTick(() => {
                this.initData.modalData.loading = true;
            });
        }, 1000);
    }
    //状态过滤
    Filter(type:any) {
        this.initData.searchInfo.AuditStatus = type;
        this.initData.tableData.currentIndex = type;
        this.GetData();
        //格式化一览表
        let ind = null;
        if(this.initData.searchInfo.AuditStatus != undefined && this.initData.searchInfo.AuditStatus != 2){
            this.initData.tableData.newTitle.map( (item:any,index:any) => {
                    if(item.title == "信息一览表"){
                        ind  = index;
                        this.initData.tableData.newTitle.splice(ind,1);
                    }
            } )
        } else {
            this.initData.tableData.newTitle.push({
                    title: '信息一览表',
                    key: 'excel',
                    width: 150,
                    align: 'center',
                    render: (h:any, params:any)=>{
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.exportExcel(params.row);
                                }
                            }
                        },'一览表')
                    }    
                });
        }
    }
    //重置弹窗
    ResetForm(type:any) {
        if(!type){
            (this as any).$refs.ScientficProjectAdd.ResetForm();
        }
    }
    //项目提交
    Submit() {
        (this as any).$refs.ScientficProjectAdd.Submit('add');
    }
    //跳转详情
    ToDetail(e:any) {
        (this as any).reloadComponent('scientficProjectDetail');
        this.$nextTick( () => {
            this.$router.push({
                name: 'scientficProjectDetail',
                query: {
                    id: e.id
                }
            })
        } )  
    }
    //获取表格数据
    async GetData() {
        this.initData.tableData.loading = true;
        let temp = (await Ajax.get('/api/services/app/ResearchProject/GetProjectByPageAsync', {params: this.initData.searchInfo})).data.result;
        if(!temp.pageResult.items.length) this.$Message.error('暂无数据');
        //格式化
        this.initData.tableData.content = temp.pageResult.items;
        this.initData.tableData.statistic = temp.statistic;
        this.initData.tableData.totalCount = temp.pageResult.totalCount;
        //加载
        this.initData.tableData.loading = false;

    }
    //获取字典数据，填充到搜索框的组件内
    async GetDic() {
        await this.$store.dispatch('project/GetbearerOrg');
        await this.$store.dispatch('project/GetResearchProjectCatalog');
        this.initData.dicData.bearerUnitPart = this.$store.state.project.bearerOrgId;
        this.initData.dicData.researchProjectCatalog = this.$store.state.project.researchProjectCatalog;
    }
    //提交搜索数据
    Search() {
        this.GetData();
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchInfo.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchInfo.MaxResultCount = perPage;
        this.GetData()
    }
    async mounted() {
        await this.GetDic();
        this.GetData();
        this.setDropdownCheckAllList();
    }
}
